import { createSlice } from '@reduxjs/toolkit';
import client from 'api/apiClient';
import { notify } from 'components/Common/Toast';
import { createAsyncThunkWrapper } from 'redux/thunk/createAsyncThunkWrapper';
import { ParishMembersState, SendEmailPayload } from 'types/community';
import { getDefaultCompanyId } from 'utils/helpers';

const initialState: ParishMembersState = {
    parishList: [],
    loading: false,
    error: null,
};
interface FetchParishMembersPayload {
    searchText: any;
}
export const fetchParishMembers = createAsyncThunkWrapper<any, FetchParishMembersPayload>(
    'parishMembers/fetchParishMembers',
    async ({ searchText }: FetchParishMembersPayload, { getState }) => {
        const state: any = getState();
        const defaultCompanyId = getDefaultCompanyId(state);

        if (!defaultCompanyId) {
            return;
        }
        const response: any = await client.get('/customer/searchCustomer', {
            headers: {
                searchText,
                companyId: defaultCompanyId,
            },
        });

        return response.customers || [];
    }
);

export const inviteNewMember = createAsyncThunkWrapper<any, SendEmailPayload>(
    'parishMembers/inviteNewMember',
    async (payload: SendEmailPayload) => {
        const response: any = await client.post('/email/sendEmail', payload);
        if (response?.code === 200) {
            notify('Invitation Sent Successfully!', 'success');
        }
        return response;
    }
);

const parishMemberSlice = createSlice({
    name: 'parishMembers',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchParishMembers.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchParishMembers.fulfilled, (state, action) => {
            state.loading = false;
            if (!action.payload) return;
            state.parishList = action.payload || [];
        });
        builder.addCase(fetchParishMembers.rejected, (state) => {
            state.loading = false;
        });
    },
});

export default parishMemberSlice.reducer;
